<template>
  <slot v-bind="{ openItems, showChildren }"></slot>
</template>

<script>
export default {
  props: {},
  data() {
    return {
      openedItems: {}
    };
  },
  computed: {},
  methods: {
    openItems(id) {
      if (id in this.openedItems === false) {
        this.openedItems[id] = false;
      }
      this.openedItems[id] = !this.openedItems[id];

      console.log(this.openedItems);
    },
    showChildren(id) {
      return id in this.openedItems && this.openedItems[id];
    }
  },
  mounted() {}
};
</script>

<style lang="scss" scoped></style>
